<template>
      <v-dialog v-model="open" :max-width="tamModal" :scrollable="$root.isTouch == false" :fullscreen="$root.isTouch"
            persistent>
            <v-card elevation="11">
                  <v-card-title class="bg-title-card">
                        <span class="white--text headline" v-html="obModal.titulo"></span>
                  </v-card-title>
                  <v-card-text>
                        <v-form ref="form">
                              <v-container fluid grid-list-sm>
                                    <v-row dense>
                                          <v-col cols="6">
                                                <v-text-field label="Nombre Perfil *" color="textbox"
                                                      v-model="obModal.perfil"
                                                      :rules="_.concat(requeridoRegla,soloLetrasRegla(3,obModal.perfil,100))"
                                                      outlined dense />
                                          </v-col>
                                          <v-col cols="6">
                                                <v-autocomplete label="Estado *" color="textbox"
                                                      :items="_.filter(listGeneral.listEstado,(v)=>{ return (v.visualiza == 'true'); })"
                                                      item-text="nombre_estado" item-value="id_estado"
                                                      :rules="requeridoRegla" v-model='obModal.idEstado' outlined
                                                      dense />
                                          </v-col>
                                    </v-row>

                                    <v-row dense>
                                          <v-col cols="12" sm="6"/>
                                          <v-col cols="12" sm="6">
                                                <v-text-field label="Buscar" v-model="obModal.search" color="textbox" clearable dense prepend-inner-icon="search" />
                                          </v-col>
                                    </v-row>

                                    <v-row dense>
                                          <v-col cols="12">
                                                <v-data-table :search="obModal.search" :headers="listGeneral.cabeceraModal" :items="listGeneral.detalleModal"
                                                      class="elevation-3">

                                                      <template v-slot:item.name="{ item }">
                                                            <v-simple-checkbox v-model="item.check" :ripple="false"></v-simple-checkbox>
                                                      </template>

                                                      <template v-slot:no-results>
                                                      Tu búsqueda de "<span v-html="obModal.search"></span>" no arrojó resultados.
                                                      </template>
                                                </v-data-table>
                                          </v-col>
                                    </v-row>

                                    <v-row dense>
                                          <v-col class="text-right">
                                                <v-btn outlined rounded color="danger" class="mr-1"
                                                      @click="clear(false)" :disabled="disabled">Cancelar</v-btn>
                                                <v-btn rounded dark color="primary" @click="validar" :disabled="disabled">Guardar</v-btn>
                                          </v-col>
                                    </v-row>
                              </v-container>
                        </v-form>
                  </v-card-text>
            </v-card>
      </v-dialog>
</template>

<script>
      export default {
            name: 'ModalPerfilModuloOpcionComponent',
            inject: ['close', 'submit'],
            props: {
                  open: {
                        type: Boolean,
                        default: false
                  },
                  obModal: {
                        type: Object,
                        default: {}
                  },
                  listGeneral: {
                        type: Object,
                        default: {}
                  },
                  parametros: {
                        type: Object,
                        default: {}
                  },
            },
            data: () => ({
                  disabled: false,
            }),
            created() {
                  if (!_.isUndefined(this.$refs.form))
                        this.$refs.form.resetValidation()
            },
            watch: {
                  open(val) {
                        if (!_.isUndefined(this.$refs.form))
                              this.$refs.form.resetValidation()
                  }
            },
            computed:{
                  listCurrentSend(){
                        var l = _.get(this.listGeneral,'detalleModal',[]);
                        return _.filter(l,(v)=>{ return v.check != v.checkOld });
                  }
            },
            methods: {
                  clear() {
                        if (!_.isUndefined(this.$refs.form))
                              this.$refs.form.resetValidation();
                        this.close(false);
                  },
                  validar() {
                        try {
                              if (!this.$refs.form.validate()) throw mensajeEstandar.corregirInformacion;
                                    this.submit(this.listCurrentSend);
                        } catch (ex) {
                              mensajesAlerta(ex, 'I');
                              this.disabled = false;
                        }
                  }
            },
      }
</script>